import { useFirstBlockingRequest } from '../../Flux/Selector/Application/GetFirstBlockingRequestsSelector.js'
import type React from 'react'
import { useEffect, useRef } from 'react'

export const RequestInProgressWidget: React.FC<unknown> = () => {
  const element = useFirstBlockingRequest()
  const dialogRef = useRef<HTMLDialogElement>(null)

  useEffect(() => {
    if (!dialogRef || !dialogRef.current) return
    if (element && !dialogRef.current.open) {
      dialogRef.current.showModal()
    } else if (!element && dialogRef.current.open) {
      dialogRef.current.close()
    }
  }, [dialogRef, element])

  return (
    <dialog id="request-in-progress-widget" className="modal" ref={dialogRef}>
      <div className="modal-box w-2/5 max-w-full h-auto max-h-[90vh] overflow-auto">
        {element && (
          <div className="m-auto">
            <div className="p-6">
              <h3 className="text-lg font-bold mb-4">An operation is in progress: {element.title}</h3>
              <p className="mb-4">{element.message}</p>
            </div>
            <div className="p-6 flex flex-col w-full h-full justify-center items-center">
              <span className="loading loading-spinner loading-lg"></span>
            </div>
          </div>
        )}
      </div>
    </dialog>
  )
}
